import { render, staticRenderFns } from "./cameras_config_add.vue?vue&type=template&id=1d7fc624"
import script from "./cameras_config_add.vue?vue&type=script&lang=js"
export * from "./cameras_config_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports